export function getTabclixCode() {

    let params = new URL(document.location).searchParams;
    // let userToken = params.get("tabclix"); 
    return document.getElementById("tbx_emb_src")?document.getElementById("tbx_emb_src").getAttribute("code"):params.get("tabclix");
}